import type { DraftPayload } from './draft.js'
import type { FieldDef, OptionsFromRows } from './types.js'

export function hasRowOptions(field: FieldDef): field is FieldDef & { optionsFromRows: OptionsFromRows } {
  return field.optionsFromRows !== undefined
}

/**
 * The distinct, non-blank text values of one field across a draft's rows of one section,
 * in row order. Pre-loaded rows are draft rows too, so they are included.
 */
export function rowOptionValues(payload: DraftPayload | undefined, source: OptionsFromRows): string[] {
  const rows = payload?.tabs[source.tab]?.rows[source.section] ?? []
  const seen = new Set<string>()
  for (const row of rows) {
    const value = row.values[source.field]
    if (typeof value !== 'string') continue
    const name = value.trim()
    if (name !== '') seen.add(name)
  }
  return [...seen]
}
